import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { ClaimsModule } from './app/claims.module';
import { environment } from './environments/environment';
import { ProductEnum } from 'environments/products/product.enum';

// "hack" for lazy loading modules
const paths = location.pathname.split('/');
let _publicPath = '';
for (const key in paths) {

    const productFromPath = paths[key] === 'majetek' ? 'majetok' : paths[key];

    if ((Object.values(ProductEnum) as Array<string>).includes(productFromPath)) {
        _publicPath = paths[key] + '/';
        break;
    }
}

declare var __webpack_public_path__: string;
__webpack_public_path__ = _publicPath;

if ((document as any).aemIntegrationAppServerURL && (document as any).aemIntegrationAppClaimType) {
    __webpack_public_path__ =
        (document as any).aemIntegrationAppServerURL + (document as any).aemIntegrationAppClaimType + '/';
}


if (environment.production) {
    enableProdMode();
}

platformBrowserDynamic().bootstrapModule(ClaimsModule)
    .catch(err => console.error(err));
